import Point from '../Utility/Point';

export const defaultCanvasSize: Point = new Point(1351, 760);
